import { render, staticRenderFns } from "./o-user-image.vue?vue&type=template&id=afe58d92&scoped=true&"
import script from "./o-user-image.vue?vue&type=script&lang=js&"
export * from "./o-user-image.vue?vue&type=script&lang=js&"
import style0 from "./o-user-image.vue?vue&type=style&index=0&id=afe58d92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe58d92",
  null
  
)

export default component.exports